import React, { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { Popover } from '@moda/om';
import { hrefFor } from '../../routers';
import { useJustAddedItem } from './useJustAddedItem';
import { MiniCartDropdown } from './MiniCartDropdown';
import { MiniCartLink } from './MiniCartLink';

type Props = {
  screen?: 'mobile' | 'desktop';
};

export const MiniCart: React.FC<Props> = ({ screen = 'desktop' }) => {
  const location = useLocation();
  const [show, setShow] = useState(false);
  const { justAddedItem, dismiss, persist } = useJustAddedItem();

  useEffect(() => {
    setShow(justAddedItem != null);
  }, [justAddedItem, setShow]);

  const handleHide = useCallback(() => {
    setShow(false);
    dismiss();
  }, [setShow, dismiss]);

  const handleShow = useCallback(() => {
    setShow(true);
    persist();
  }, [setShow, persist]);

  if (location.pathname === hrefFor.ShoppingBagPage()) return <MiniCartLink />;

  return screen === 'desktop' ? (
    <Popover
      open={show}
      anchor="topRight"
      content={
        <MiniCartDropdown justAddedItem={justAddedItem} onHide={handleHide} onHover={handleShow} />
      }
    >
      <MiniCartLink />
    </Popover>
  ) : (
    <>
      <MiniCartLink />
      {show && (
        <div>
          <MiniCartDropdown
            justAddedItem={justAddedItem}
            onHide={handleHide}
            onHover={handleShow}
          />
        </div>
      )}
    </>
  );
};
